import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'camelCase'
})
export class CamelCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
